






import contacts from "../../contacts/contacts.vue";

export default {
    components: {
        contacts,
    },
};
